module.exports = __webpack_public_path__ + "static/img/moshishuoming.20a1973d.jpeg";